import { Component, inject, effect } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { SiteState } from '@next/core-lib/site';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

import { ApplicationGroup, Contactperson, NewRole } from '../../models/contactperson.model';
import {
  selectApplicationGroups,
  deleteGroupUseraccess,
  setUseraccess,
  initAuthorization,
} from '../../store/contactperson.actions';
import {
  selectSelectedRole,
  hasUnselectedApplicationGroups,
  selectSelectedApplicationGroups,
  selectRoles,
  getSelectedContactperson,
  selectApplicationsForGroup,
} from '../../store/contactperson.selectors';

@Component({
  selector: 'app-contactperson-authorizations',
  templateUrl: './contactperson-authorizations.component.html',
  standalone: false,
})
export class ContactpersonAuthorizationsComponent {
  private readonly store = inject<Store<SiteState>>(Store);

  hasUnselectedApplicationGroups$: Observable<boolean> = this.store.select(
    hasUnselectedApplicationGroups,
  );
  selectedApplicationGroups$: Observable<ApplicationGroup[]> = this.store.select(
    selectSelectedApplicationGroups,
  );
  roles$: Observable<NewRole[]> = this.store.select(selectRoles);

  private readonly selectedContactpersonSignal = toSignal(
    this.store.select(getSelectedContactperson).pipe(filter((cp) => !!cp)),
    { initialValue: null as Contactperson | null },
  );

  constructor() {
    effect(() => {
      const contactperson = this.selectedContactpersonSignal();
      if (contactperson?.id) {
        this.store.dispatch(initAuthorization({ externalId: contactperson.id.toString() }));
      }
    });
  }

  openApplicationGroupDialog = () => this.store.dispatch(selectApplicationGroups());

  getSelectedRole(applicationKey: string) {
    return this.store.select(selectSelectedRole, applicationKey);
  }

  getApplications(groupId: number) {
    return this.store.select(selectApplicationsForGroup, groupId);
  }

  deleteGroupUseraccess(groupId: number) {
    return this.store.dispatch(deleteGroupUseraccess({ groupId }));
  }

  setUseraccess(applicationKey: string, roleKey: string) {
    return this.store.dispatch(setUseraccess({ applicationKey, roleKey }));
  }
}
